import { useEffect } from 'react';

import { setPageTitle } from '@backrs_ui/grow-ui/src/redux/appState/appState';
import { useAppDispatch } from '@backrs_ui/grow-ui/src/redux/hooks';

export const usePageTitle = (title: string | undefined) => {
  const dispatch = useAppDispatch();

  useEffect(() => {
    if (title) dispatch(setPageTitle(title));

    return () => {
      dispatch(setPageTitle(null));
    };
  }, [title, dispatch]);
};
